//#region imports
import React, { useEffect, useState } from 'react';

// styling
import { Colors, Spacing } from '_styles';

// functions
import { formatTimeLineDashboardAssistance, parseFlightNumber, processName } from '_utils/functions';

// redux
import { useDispatch, useSelector } from 'react-redux';
import { openPaxContextMenuModal, setPaxMenuContext } from '_redux/slices/utils/menu-context';
import { selectFlightListIndexed } from '_redux/slices/timeline/flight-information-list';
import { selectSelectedTasksList, setSelectedTaskList, selectSelectedTasksListIds, setSelectedTask } from '_redux/slices/timeline/selected-task';
import { selectUsedTheme } from '_redux/slices/timeline/theme';
import { selectRemovePaxNamePrefix } from '_redux/slices/timeline/timeline-control';
import { selectIata } from '_redux/slices/main-screen/user';


// time formating
import moment from 'moment';

// custom components
import JobStatus from '../../../scenes/portal/timeline/job-components/job-status';

// icons
import { PiNotepadFill } from "react-icons/pi";


//#endregion

const PassengerRow = ({ passenger, index, flightList, selectedTasksList, selectedTasksIds, removePrefixName }) => {

    const loggedInUserIata = useSelector(selectIata);
    const usedTheme = useSelector(selectUsedTheme);
    const paxName = formatPassengerName(passenger);
    const arrivalAirport = passenger?.flightConfirmationDetails?.destination ?? passenger?.flightInformation?.arrivalAirport ?? "";

    let flightNumber = "";

    let gate = "";
    let stand = "";
    let operatingStatus = "";
    let originalTime = "";
    let flightTime = "";
    let flightType = passenger?.flightConfirmationDetails?.destination == loggedInUserIata ? "inbound" : "outbound";

    if (passenger?.flightConfirmationDetails) {
        flightNumber = passenger.flightConfirmationDetails.carrierCode + passenger.flightConfirmationDetails.flightNumber;
    }
    else if (passenger?.flightInformation) {
        flightNumber = passenger.flightInformation?.flightNumber ?? "";
    }

    if (flightNumber != "") {

        // check flight list is valid
        if (flightList && Object.keys(flightList) && Object.keys(flightList).length > 0) {

            let origin = "";
            let destination = "";
            if (passenger?.flightConfirmationDetails) {
                origin = passenger?.flightConfirmationDetails?.origin;
                destination = passenger?.flightConfirmationDetails?.destination;
            } else if (passenger?.flightInformation) {
                origin = passenger?.flightInformation?.departureAirport;
                destination = passenger?.flightInformation?.arrivalAirport;

            }

            // try find our flight
            let flightDocument = flightList[`${flightNumber}_${origin}_${destination}`];

            if (flightDocument != undefined) {

                // check for gate / stand info
                if (flightDocument?.stand) stand = flightDocument?.stand;
                if (flightDocument?.gate) gate = flightDocument?.gate;
                if (flightDocument?.operatingStatus) operatingStatus = flightDocument?.operatingStatus
                if (flightDocument?.originalFlightTime) originalTime = flightDocument?.originalFlightTime
                if (flightDocument?.operationInfo?.time) flightTime = flightDocument?.operationInfo?.time

            };
        }
    }

    if (flightNumber.startsWith("U2")) {
        flightNumber = flightNumber.replace("U2", "EZY");
    }

    const dispatch = useDispatch()

    //#region context-menu

    const handRightClick = (e) => {
        e.preventDefault();
        dispatch(openPaxContextMenuModal(true))
        const paxData = {
            locationPoints: {
                x: e.pageX,
                y: e.pageY
            },
            passenger
        }
        dispatch(setPaxMenuContext(paxData))
    };

    const handlePaxClick = () => {

        // log pax
        console.log('Clicked pax:', passenger);

        // check if the pax is rejected 
        if (passenger?.rejectedPax == true || passenger?.originalBookingDoc?.rejectedPax == true || passenger?.rejectedALTPax == true) return;
        if (passenger?.isALTPickUp && passenger?.assignedTime) return;

        // check if pax has already been assigned
        if (passenger?.paxPositionInfo?.activity?.toLowerCase() == "assigned") {
            // cant reassign it so do not select it, check if its already selected
            let selectedTasksIds = Array.isFullArray(selectedTasksList)
                ? selectedTasksList?.map((element) => element?._id)
                : [];
            // check if the selected tasks list include the selected task or not
            if (selectedTasksIds?.includes(passenger?._id)) {
                // remove the clicked task from selected tasks list
                dispatch(
                    setSelectedTaskList(
                        selectedTasksList?.filter((item) => item?._id != passenger._id)
                    )
                );

            } else {
                dispatch(setSelectedTaskList([...selectedTasksList, passenger]));
                dispatch(setSelectedTask(passenger))
            }
        }
        else {
            let selectedTasksIds = Array.isFullArray(selectedTasksList)
                ? selectedTasksList?.map((element) => element?._id)
                : [];

            // check if the selected tasks list include the selected task or not
            if (selectedTasksIds?.includes(passenger._id)) {
                // remove the clicked task from selected tasks list
                dispatch(
                    setSelectedTaskList(
                        selectedTasksList?.filter((item) => item?._id != passenger._id)
                    )
                );

            } else {
                dispatch(setSelectedTaskList([...selectedTasksList, passenger]));

            }
        }
    }

    //#endregion

    //#region functions

    function formatPassengerName(passenger) {
        let paxName = "";

        if (passenger) {
            if (passenger.name) {
                paxName = passenger.name;
            } else if (passenger.passengerInformation?.title) {
                paxName = passenger.passengerInformation.title;
            }
        }

        if (paxName) {

            paxName = processName(paxName, removePrefixName);
        }

        return paxName;
    }

    // truncate name if it is too long
    function truncateName(name) {
        if (name.length > 10) {
            return name.substring(0, 10) + '...';
        }
        return name;
    }

    const getCardClickedColor = () => {
        if (passenger?.isALTPickUp) return '#f5b5d8';
        else return '#C7E2FD';
    }
    //#endregion

    return (
        <div
            style={{
                flex: 1,
                margin: 0,
                padding: Spacing.SCALE_2,
                marginBottom: Spacing.SCALE_8,
                color: usedTheme.TEXT_COLOR,
                width: '170px',
                maxWidth: '190px',
            }}
            onClick={handlePaxClick}
            key={index}
            onContextMenu={(e) => { handRightClick(e) }}
        >

            <div style={{
                borderStyle: "solid",
                borderColor: usedTheme.BORDER_COLOR,
                borderWidth: "1.5px",
                borderRadius: "5px",
                backgroundColor: selectedTasksIds?.includes(passenger?._id) ? getCardClickedColor() : usedTheme.BACKGROUND_COLOR,
            }}>

                {/* top half of card */}
                <div style={{
                    display: "flex",
                    flex: 1,
                    justifyContent: "space-between",
                    backgroundColor: selectedTasksIds?.includes(passenger?._id) ? getCardClickedColor() : usedTheme.BACKGROUND_COLOR,
                }}>

                    {/* assistance */}
                    <div style={{ flex: 1, display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', marginLeft: Spacing.SCALE_2 }}>
                        <p style={{ margin: "0px 0", textAlign: "center", fontSize: 10, fontWeight: 'bold' }} data-tippy-content={passenger?.isALTPickUp ? passenger?.passengerInformation?.assistance : passenger?.assistance}>{formatTimeLineDashboardAssistance(passenger?.isALTPickUp ? passenger?.passengerInformation?.assistance : passenger?.assistance)}</p>
                    </div>

                    {/* note icon */}
                    <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }} {...(passenger.notes ? { 'data-tippy-content': passenger.notes } : {})}>
                        {passenger?.notes && <PiNotepadFill color={Colors.GRAY_DARK} size={14} />}
                    </div>

                    {/* flight time */}
                    <div style={{ flex: 1, display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
                        <p style={{ margin: "0px 0", textAlign: "center", fontSize: 10, marginRight: Spacing.SCALE_2 }}>
                            {moment(new Date(flightTime ? flightTime : new Date())).format('HH:mm')}
                            {/*{`[${operatingStatus}]`}*/}
                        </p>
                    </div>

                </div>

                {/* horizontal line break */}
                <hr style={{ margin: "0px" }} />

                {/* middle half of card */}
                <div style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'space-between',
                    padding: Spacing.SCALE_2,
                    backgroundColor: selectedTasksIds?.includes(passenger?._id) ? getCardClickedColor() : usedTheme.BACKGROUND_COLOR,
                }}>

                    {/* passenger name */}
                    <div style={{ flex: 1.5, overflowY: 'auto' }} data-tippy-content={paxName}>
                        <p style={{ margin: "0px 0", fontSize: 10, fontWeight: "500", }}>
                            {truncateName(paxName)}
                        </p>
                    </div>

                    {/* status information */}
                    <div style={{ display: "flex", flex: 1, alignItems: "flex-end", justifyContent: 'flex-end' }} data-tippy-content="Assistance Task Status">

                        {/* status */}
                        <div style={{ display: 'inline-flex', alignItems: 'center', flex: 1 }}>
                            <JobStatus job={passenger} booking={true} forLocationPanel={true} />
                        </div>
                    </div>

                </div>

                {/* bottom half of card */}
                <div style={{
                    backgroundColor: passenger?.isALTPickUp
                        ? passenger?.isGateRelocation ? "#ebb71c" : 'purple'
                        : flightType == 'inbound' ? Colors.DARK_GREEN : Colors.PRM_LIGHT_BLUE, margin: 0, padding: 0
                }}>
                    <div style={{ display: "flex", flex: 1, justifyContent: "space-between", padding: Spacing.SCALE_2 }}>

                        {/* flight number */}
                        <div style={{ flex: 1, display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
                            <p style={{ margin: "0px 0", textAlign: "center", fontSize: 11, fontWeight: '600', color: 'white' }} data-tippy-content="Flight Number">
                                {parseFlightNumber(flightNumber)?.carrierCode ?? ""} {parseFlightNumber(flightNumber)?.flightNumber ?? ""}
                            </p>
                        </div>

                        {/* iata code */}
                        <div style={{ flex: 1, alignItems: 'center', }}>
                            <p style={{ margin: "0px 0", textAlign: "center", fontSize: 11, fontWeight: '600', color: 'white' }}>{arrivalAirport ?? ""}</p>
                        </div>

                        {/* gate + stand */}
                        <div style={{ flex: 1, display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>

                            {/* gate */}
                            <p style={{ margin: "0px 0", textAlign: "center", fontSize: 11, color: 'white' }}>{gate && gate == 'N/A' ? "" : gate ? "G:" + gate : ""}</p>

                            {/* stand */}
                            <p style={{ margin: "0px 0", textAlign: "center", fontSize: 11, color: 'white' }}>{stand && stand == 'N/A' ? "" : stand ? "S:" + stand : ""}</p>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    )
}

const PassengerListMiniTable = (props) => {

    //#region redux
    const flightList = useSelector(selectFlightListIndexed)
    const selectedTasksList = useSelector(selectSelectedTasksList);
    const selectedTasksIds = useSelector(selectSelectedTasksListIds);
    const removePrefixName = useSelector(selectRemovePaxNamePrefix)
    //#endregion

    //#region local state
    const [currentData, setCurrentData] = useState([])

    //#endregion

    //#region useEffect
    useEffect(() => {
        if (props?.passengers) {
            setCurrentData(props.passengers)
        }
    }, [props]);

    //#endregion


    return (
        <div>

            {/* table data */}
            <div >
                {currentData && currentData.length && currentData.length > 0 ? currentData.map((passenger, index) => {
                    return (
                        <div style={{ marginTop: Spacing.SCALE_10 }}>
                            {/* body list */}
                            <PassengerRow passenger={passenger} index={index} flightList={flightList} selectedTasksList={selectedTasksList} selectedTasksIds={selectedTasksIds} removePrefixName={removePrefixName} />
                        </div>
                    )
                })
                    :
                    <p style={{
                        fontSize: 10,
                        color: Colors.GRAY_DARK,
                        fontWeight: '500',
                        textAlign: 'center'
                    }}>{''}</p>
                }
            </div>
        </div>
    );
};

export default PassengerListMiniTable;
